
import React, { useState } from 'react';
import './index.css';
import { Col, Row, Tooltip } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { getPrimaryMobile } from '__utils/common-utils';
import ConfirmationModal from '../../components/confirmation-modal/index'; 
import { useForm } from 'react-hook-form';
import CustomRadio from 'components/custom-radio';
import { ClickableSpan, FormErrorMessageSpan, InputMintDiv } from 'views/common-styled-components';
import Checkbox from '__utils/customisedCheckBox';
import { SuccessButton } from 'components/button';
import { fetchPost, get, getDefaultHeaders, getFormDataFromJson } from '__utils/ajax-wrapper';
import { ENDPOINTS } from 'constants/endpoints';
import { AjaxError, AjaxResponse } from 'rxjs/ajax';
import useFlashToggler from 'hooks/use-flash-toggler';
import { GreenBgSmallBtn } from 'views/stp-swp/stp-swp-helper'; 
import { useMediaQuery } from 'react-responsive';
import moment from 'moment';

interface OperationProps {
    onCancel: Function;
    folioData: any;
}

const PortfolioRedeem: React.FC<OperationProps> = ({ onCancel, folioData }) => {
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const inProgressAmount = folioData?.inProgressAmount || 0;
    const inProgressUnits = folioData?.inProgressUnits || 0;

    const flash = useFlashToggler();
    const [redeemData, setRedeemData] = useState<any>();
    const [stage, setStage] = useState<'otp' | 'Redeem' | 'redeemSuccess'>('Redeem');
    const [otpSent, setIsOTPsent] = useState<boolean>(false);
    const [isRelianceFund, setIsRelianceFund] = useState<boolean>(false);
    const [isOTPpresent, setIsOTPpresent] = useState<boolean>(false);
    const [canResendOTP, setCanResendOTP] = useState<boolean>(false);
    const [redemptionTypeAll, setRedemptionTypeAll] = useState<boolean>(false);
    const [redeemTypeTitle, setRedeemTypeTitle] = useState<any>('Amount to redeem');
    const [redeemValue, setRedeemValue] = useState<any>('amount');
    const [approxValue, setApproxValue] = useState<any>();
    const [remainingValue, setRemainingValue] = useState<any>((folioData?.todaysNAV*(folioData?.unitsAllocated - inProgressUnits) - inProgressAmount).toFixed(3));

    const { register, handleSubmit, formState: { errors }, clearErrors, setValue, getValues } = useForm({ mode: 'onChange' });
    const redeemType = redeemValue === 'amount' ? `amount` : `unit`;

    const changeRedemptionOption = (redeemType: string) => {
        setValue('redeemAmount', '');
        clearErrors('redeemAmount');
        if (redeemType === 'amount') {
            setRedeemTypeTitle('Amount to redeem');
            setRedeemValue(redeemType);
            setRemainingValue((folioData?.todaysNAV*(folioData?.unitsAllocated - inProgressUnits) - inProgressAmount).toFixed(3));
            redemptionTypeAll && setValue('redeemAmount', (folioData?.todaysNAV*(folioData?.unitsAllocated - inProgressUnits) - inProgressAmount).toFixed(3));
        } else {
            setRedeemTypeTitle('Units to redeem');
            setRedeemValue(redeemType);
            setRemainingValue((((folioData?.currentValue-folioData?.inProgressAmount)/folioData?.todaysNAV) - inProgressUnits).toFixed(3));
            redemptionTypeAll && setValue('redeemAmount', (((folioData?.currentValue-folioData?.inProgressAmount)/folioData?.todaysNAV) - inProgressUnits).toFixed(3));
        }
    }

    const calcApproxValue = (redeemValue:any, value:any) => {
        let approxAmountUnits = redeemValue === 'amount' ? value/folioData?.todaysNAV : value*folioData?.todaysNAV;
        return approxAmountUnits.toFixed(3);
    }

    const onRedemptionSubmit = (data: any) => {
      setRedeemData(data);
      sendTransactionOtp();
      setStage('otp');
    }

    //@purpose:- send transaction type
    const sendTransactionOtp = () => {
        get(`${ENDPOINTS.GET_SEND_TRANSACTION_OTP}?flowType=3`, getDefaultHeaders(), true)
            .subscribe((response: AjaxResponse | AjaxError) => {
                setIsOTPsent(true);
                setTimeout(() => {
                    setCanResendOTP(true);
                }, 30000);
            }, (error: AjaxError) => {
                flash.error('Failed to send transaction OTP');
            });
    }
    const resendOTP = () => {
        setCanResendOTP(false);
        setIsOTPpresent(true);
        sendTransactionOtp();
    }

    //@purpose:- verify OTP,if correct,send transactionRequest
    const verifyRedeemOTP = (folioRedeemFormData: any): void => {
        const formData = getFormDataFromJson({ otp: '' + folioRedeemFormData.otp, flowType: 3 });
        fetchPost(
            `${ENDPOINTS.POST_VERIFY_TRANSACTION_OTP}`, formData, null, true
        ).then((response: any) => {
            if (response && response.operationMessage === "success") {
                validateTransactionRequest();
            } else if(response.operationMessage === "failure" && response?.responseData?.expired){
                flash.error("Your OTP has expired. Please request a new OTP.");
            }
            else {
                flash.error("Please enter correct OTP.");
            }
        }).catch((error: any) => {
            flash.error("Failed to verify OTP.");
        })
    }

    const validateTransactionRequest = () => {
        const data = {
            isin: folioData.metaData?.isin,
            folioNo: folioData?.folioNo,
            redeemType: redeemData?.redeemType,
            amount: !redeemData?.redeemAll && redeemData?.redeemType === 'amount' ? redeemData?.redeemAmount : 0,
            units: !redeemData?.redeemAll && redeemData?.redeemType === 'units' ? redeemData?.redeemAmount : 0,
            allRedeem: redeemData?.redeemAll ? 'Y' : 'N'
        };

        const formData = getFormDataFromJson(data);
        fetchPost(
            `${ENDPOINTS.POST_REDEEM_REQUEST}`, formData, null, true
        ).then((response: any) => {
              if (response && response?.meta?.message === "success") {
                const isReliance = folioData?.metaData?.schemeName?.indexOf("Reliance");
                if (isReliance > -1)
                    setIsRelianceFund(true);
                else
                    setIsRelianceFund(false);
                setStage('redeemSuccess');
            } else {
                flash.error(response?.meta?.error);
            }
        }).catch((error: any) => {
            flash.error("Something went wrong. Please try again later");
        });
    }
    
    const validateRedemtionMultiple = () => {
        if(redeemValue === 'amount' && !redemptionTypeAll) {
            return Number((Number(getValues('redeemAmount'))/folioData?.redemptionAmountMultiple)%1) ! == 0
        }
    }

    const popupContent = () => {
        if (stage === 'otp') {
            return (<div>
                <div className="otpBody">
                    {otpSent && <p className='greenTxt mb8 ft12 fw-300'> OTP has been {isOTPpresent ? 'resent' : 'sent'} to your Registered Mobile Number {getPrimaryMobile()}</p>}
                </div>
                <div>
                    <form name="otpVerifcationForm" id="otpVerifcationForm" onSubmit={handleSubmit(verifyRedeemOTP)}>
                        <div className='mb16'>
                            <InputMintDiv>
                                <input
                                    name='otp'
                                    type="number"
                                    style={{ letterSpacing: "20px", fontSize: "20px", textAlign: "center", marginTop: "8px" }}
                                    ref={register({
                                        required: {
                                            value: !redemptionTypeAll,
                                            message: 'Please enter OTP'
                                        },
                                        minLength: {
                                            value: 6,
                                            message: 'Please enter valid 6-digit OTP'
                                        },
                                        maxLength: {
                                            value: 6,
                                            message: 'Please enter valid 6-digit OTP'
                                        },
                                        pattern: {
                                            value: /^\d{6}$/,
                                            message: 'Please enter valid 6-digit OTP'
                                        }
                                    })}
                                />
                                {errors?.otp && <FormErrorMessageSpan>{errors?.otp.message}</FormErrorMessageSpan>}
                            </InputMintDiv>
                        </div>
                        <SuccessButton type="submit">VERIFY & REDEEM</SuccessButton>
                    </form>
                    <div className='otpButtonDiv'>
                        {canResendOTP && <ClickableSpan onClick={() => resendOTP()}>Resend OTP?</ClickableSpan>}
                        {!canResendOTP && <span className='greenTxt ft14 fw-300'>Please wait for a few seconds before you can request another OTP.</span>}
                    </div>
                </div>
            </div>)
        }
        else if (stage === 'Redeem') {
            return (
            <>
              <div className="popup-body">
                <h3>{folioData?.metaData?.schemeShortName}</h3>
                <ul className='redemption-sec'>
                    <li>Redemption time
                        <p>2 working days</p>
                    </li>
                    <li>Latest NAV date
                        <p>{moment(folioData?.latestNavDateByBatch).format('Do MMMM YYYY')}</p>
                    </li>
                </ul>
                <form name="otpVerifcationForm" id="otpVerifcationForm" onSubmit={handleSubmit(onRedemptionSubmit)}>
                  <div className='mb20'>
                    <p className=''>Select Redemption Option</p>
                    <Row className='mb24 mt8'>
                      <Col xs={9}>
                        <CustomRadio
                            name='redeemType'
                            value="amount"
                            defaultChecked
                            radiobuttonRef={register()}
                            onChange={(event: any) => {changeRedemptionOption(event.target.value)}}
                            label="Amount"
                        />
                      </Col>
                      <Col xs={9}>
                        <CustomRadio
                            name='redeemType'
                            value="units"
                            radiobuttonRef={register()}
                            onChange={(event: any) => {changeRedemptionOption(event.target.value)}}
                            label="Units"
                        />
                      </Col>
                    </Row>
                    <InputMintDiv className='inpt-wrap'>
                      <div>{redeemTypeTitle}</div>
                      {redeemValue === 'amount' && <span className={`ruppee-icon ${redemptionTypeAll || folioData?.tagToDisplay === 'all' ? 'disabled' : ''}`}>₹</span>}
                      <input
                        className='redemtion-inpt'
                        name='redeemAmount'
                        type="number"
                        disabled={redemptionTypeAll || folioData?.tagToDisplay === 'all'}
                        placeholder=""
                        onChange={(event) => setApproxValue(calcApproxValue(redeemValue, event.target.value))}
                        step="0.001"
                        ref={register({
                            required: {
                                value: !redemptionTypeAll,
                                message : `Please enter withdrawal ${redeemType}`
                            },
                            min: {
                                value: redeemValue === 'amount' ? folioData?.minimumRedemptionAmount : folioData?.minimumRedemptionUnits,
                                message: `The minimum withdrawal ${redeemValue === 'amount' ? `amount is ${folioData?.minimumRedemptionAmount}` : `unit is ${folioData?.minimumRedemptionUnits}`}`
                            },
                            max: {
                                value: remainingValue,
                                message: `The maximum withdrawal ${redeemType} is ${remainingValue}`
                            },
                            validate: {
                                redemtionMultiple: validateRedemtionMultiple
                            }
                        })}
                      />

                      {!redemptionTypeAll && getValues('redeemAmount') > 0 && remainingValue > 0 && 
                        <span className='approx-value'>Approx
                            {redeemValue !== 'amount' ? ` ₹${approxValue}` : ` ${approxValue} units`}
                        </span>
                      }
                      <p className='available-value'>Available
                        {redeemValue === 'amount' ? ` amt. ₹${remainingValue || 0}` : ` units ${remainingValue || 0}`}
                        <Tooltip
                            overlayClassName='redemtion-tooltip' 
                            title={
                                <span className='tooltip-color'>Available amount shown is based on the NAV of the mutual funds as on previous working day. The actual amount might change based on changes in NAV of the fund.</span>
                            } 
                            color='#fff'
                            zIndex={9999}> 
                            <span className='tooltip-icon'>&nbsp;&nbsp;<ExclamationCircleOutlined /></span>
                        </Tooltip>
                      </p>
                      {errors?.redeemAmount && errors.redeemAmount.type !== "redemtionMultiple" && <FormErrorMessageSpan>{errors?.redeemAmount.message}</FormErrorMessageSpan>}
                      {(errors.redeemAmount && errors.redeemAmount.type === "redemtionMultiple") &&
                        <FormErrorMessageSpan>Please enter multiple of {redeemValue === 'amount' ? folioData?.redemptionAmountMultiple : folioData?.redemptionUnitsMultiple}</FormErrorMessageSpan>
                      }
                    </InputMintDiv>

                    <div className='mt20'>
                      <label style={{display: 'inline-block'}}>
                        <Checkbox
                            name="redeemAll"
                            label={<span style={{fontSize: '16px', marginTop: '-3px'}}>Redeem all</span>}
                            checked={redemptionTypeAll}
                            onChange={(e: any) => {
                                setRedemptionTypeAll(e.target.checked);
                                e.target.checked && setValue('redeemAmount', remainingValue)
                                !e.target.checked && setValue('redeemAmount', '');
                                clearErrors('redeemAmount');
                            }}
                            className=""
                            checkboxRef={register()}
                            disabled={false}
                        />
                      </label>
                    </div>
                  </div>
                  <SuccessButton 
                    style={ !isMobile ? { width: '120px', position: 'relative', left: 'calc(100% - 120px)'} : {} } 
                    type="submit" 
                    disabled={errors?.redeemAmount}>Confirm</SuccessButton>
                </form>
              </div>
            </>)
        }
        else {
            return (<div>
                <div className="cancelLgContent text-center">
                    <h4>Redeem Request Received</h4>
                    <p>Your redemption request has been submitted.
                        {!isRelianceFund && <span><br />You will receive an SMS and Email from BSE for confirming the redemption. Please follow instruction in the mail for completing the redemption.</span>}
                    </p>
                </div>
                <div className='cancelRedeemBtn'>
                    <GreenBgSmallBtn onClick={() => onCancel('redeemSuccess')}>OK</GreenBgSmallBtn>
                </div>
            </div>)
        }
    }

    return <ConfirmationModal
        title={stage === "Redeem" ? "Redeem Fund" : stage === "otp" ? "Enter OTP" : "Success"}
        isTitleBordered
        closable
        onCancel={onCancel}
        modalBody={popupContent()}
    />

};

export default PortfolioRedeem;

